export default __webpack_public_path__ + "static/media/lvl.e35ae34a.jfif";